var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _circle, _path1, _path10, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLead(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "color",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.854 23.146c-1.314-1.313-1.353-2.586-1.354-2.649-.002-.274-.225-.497-.5-.497h-4.02c-.276 0-.499.227-.5.503 0 .054-.018 1.327-1.333 2.643-.143.143-.186.357-.108.545.076.188.259.309.461.309h7c.202 0 .385-.121.462-.309s.034-.402-.108-.545z",
    fill: "#90a4ae"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m22.25 4h-20.5c-.965 0-1.75.785-1.75 1.75v13.5c0 .965.785 1.75 1.75 1.75h20.5c.965 0 1.75-.785 1.75-1.75v-13.5c0-.965-.785-1.75-1.75-1.75z",
    fill: "#607d8b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m22 17h-20v-11h20z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m12 21h-2.591c-.118.501-.431 1.315-1.262 2.146-.143.143-.186.357-.108.545.076.188.259.309.461.309h3.5z",
    fill: "#7d8f97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m12 4h-10.25c-.965 0-1.75.785-1.75 1.75v13.5c0 .965.785 1.75 1.75 1.75h7.659 2.591v-4h-10v-11h10z",
    fill: "#546d79"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m9 13c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm3-7h-10v11h10-7v-.25c0-1.52 1.23-2.75 2.75-2.75h2.5c.665 0 1.275.236 1.75.628z",
    fill: "#dedede"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m9 13c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z",
    fill: "#90a4ae"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m10.25 14h-2.5c-1.52 0-2.75 1.23-2.75 2.75v.25h8v-.25c0-1.52-1.23-2.75-2.75-2.75z",
    fill: "#90a4ae"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m9 9c-1.103 0-2 .897-2 2s.897 2 2 2z",
    fill: "#7d8f97"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m9 14h-1.25c-1.52 0-2.75 1.23-2.75 2.75v.25h4z",
    fill: "#7d8f97"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 6,
    fill: "#fff",
    r: 5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m18 9c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z",
    fill: "#2196f3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m18 12c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6v.75c0 1.24-1.009 2.25-2.25 2.25s-2.25-1.01-2.25-2.25v-3c0-.414.336-.75.75-.75s.75.336.75.75v3c0 .413.336.75.75.75s.75-.337.75-.75v-.75c0-2.481-2.019-4.5-4.5-4.5s-4.5 2.019-4.5 4.5 2.019 4.5 4.5 4.5c.414 0 .75.336.75.75s-.336.75-.75.75z",
    fill: "#2196f3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1d83d4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18 0c-3.309 0-6 2.691-6 6s2.691 6 6 6v-1.5c-2.481 0-4.5-2.019-4.5-4.5s2.019-4.5 4.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 3c-1.654 0-3 1.346-3 3s1.346 3 3 3v-1.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLead);
export default __webpack_public_path__ + "static/media/lead.217f4a3fa0530f78f599b0fb3e33670b.svg";
export { ForwardRef as ReactComponent };